var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "move-up-sticky" } }, [
    _vm.getWarrantySinisterDamagesCount
      ? _c(
          "div",
          {
            staticClass: "warrantySticky container container--eq-pd",
            class: [
              { expanded: _vm.expanded },
              { "warrantySticky--externalDamage": _vm.hasExternalDamageId }
            ]
          },
          [
            _c(
              "ma-accordion",
              {
                ref: "warrantyStickyAccordion",
                attrs: { expanded: _vm.expanded }
              },
              [
                _vm.expanded === false
                  ? _c("template", { slot: "accordionTop" }, [
                      _c("p", { staticClass: "headline-medium black" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$tc(
                              "warrantyLayout.registeredDamages",
                              this.getWarrantySinisterDamagesCount,
                              { count: this.getWarrantySinisterDamagesCount }
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm.expanded === false
                  ? _c("template", { slot: "accordionBottom" }, [
                      _c(
                        "div",
                        { staticClass: "summary" },
                        _vm._l(_vm.stateWarrantySinisterSummary, function(
                          damageGroup
                        ) {
                          return _c("ul", { staticClass: "group" }, [
                            _c("li", [
                              _c(
                                "p",
                                {
                                  staticClass: "text-small blueDark mg mg--b-2"
                                },
                                [_vm._v(_vm._s(damageGroup.title))]
                              )
                            ]),
                            _c(
                              "ul",
                              { staticClass: "pd pd--l-2 damagesCart" },
                              _vm._l(damageGroup.items, function(item) {
                                return _c(
                                  "li",
                                  {
                                    staticClass:
                                      "summary__item grid mg mg--b-1",
                                    class: {
                                      active:
                                        item.external_damage_id ===
                                        _vm.externalDamageId
                                    }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-medium black mg mg--r-2"
                                      },
                                      [_vm._v(_vm._s(item.literal))]
                                    ),
                                    _vm.checkIfItemCanDelete(item)
                                      ? _c("svgicon", {
                                          staticClass: "svg-icon-action",
                                          attrs: {
                                            name: "trash",
                                            height: "18",
                                            width: "18"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleRemoveDamage(
                                                item.damage_id
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ],
              2
            ),
            _vm.expanded === true
              ? _c(
                  "div",
                  { staticClass: "warrantySticky__analysis" },
                  [
                    _c("div", {
                      staticClass: "warrantySticky__analysis__overlay"
                    }),
                    _c("div", {
                      staticClass: "warrantySticky__analysis__close",
                      on: {
                        click: function($event) {
                          return _vm.triggerExpand()
                        }
                      }
                    }),
                    _c("ma-damage-summary")
                  ],
                  1
                )
              : _vm._e(),
            _c("div", { staticClass: "mg mg--t-4 warrantySticky__actions" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  attrs: { disabled: _vm.getWarrantySinisterDamagesCount <= 0 },
                  on: {
                    click: function($event) {
                      return _vm.triggerAnalysis()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("warrantySticky.analyze")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue mg mg--r-2",
                  attrs: {
                    disabled:
                      _vm.getWarrantySinisterDamagesCount <= 0 ||
                      _vm.hasWarrantyRepairTypeNotSelected
                  },
                  on: {
                    click: function($event) {
                      return _vm.triggerPdfReport()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("warrantySticky.generateReport")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue mg mg--r-2",
                  attrs: { disabled: _vm.getWarrantySinisterDamagesCount <= 0 },
                  on: {
                    click: function($event) {
                      return _vm.triggerPdfReportFnol()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("warrantySticky.generateReportFnol")))]
              ),
              _vm.expanded
                ? _c(
                    "button",
                    {
                      staticClass: "secondaryBlue",
                      on: {
                        click: function($event) {
                          return _vm.triggerMaterialList()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("warrantySticky.materialListBtn")))]
                  )
                : _vm._e()
            ]),
            _vm.expanded && _vm.isAllianzITUSer
              ? _c("div", { staticClass: "warrantySticky__smartReport" }, [
                  _c(
                    "button",
                    {
                      staticClass: "secondaryBlue",
                      on: { click: _vm.downloadSmartReport }
                    },
                    [_vm._v(_vm._s(_vm.$t("warrantySticky.smartReport")))]
                  )
                ])
              : _vm._e(),
            _c(
              "ma-modal",
              {
                ref: "materialList",
                staticClass: "modal--materialList",
                attrs: { type: "large" }
              },
              [
                _c(
                  "template",
                  { slot: "modalContent" },
                  [_c("ma-material-summary")],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }